import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface AddExperienceToCandidateResponse extends BackendResponse {}
export interface AddExperienceToCandidateParameters extends NextApiParams {
  comment: string;
  level: number;
  from: string;
  to: string | null;
  customerId: number;
  candidateType: number;
  industryType: number;
  firm: string;
  position: string;
  references: string;
  hide: boolean;
}

export const addExperienceToCandidate = withNextApi<
  AddExperienceToCandidateResponse,
  AddExperienceToCandidateParameters
>("/cvp/CvpAddExperienceToCandidate");
